import { Link } from "react-router-dom";

export default function Logo({ size = "md" }) {
  const sizes = {
    sm: "text-xl",
    md: "text-2xl",
    lg: "text-4xl",
  };

  return (
    <Link
      to="/"
      data-testid="logo"
      className="flex items-center gap-2 group"
    >
      <span className={`font-serif font-semibold tracking-tight ${sizes[size]} text-foreground`}>
        <span className="text-[#3FD97A]">ق</span> Group<span className="text-[#3FD97A]">.</span>
      </span>
    </Link>
  );
}
